var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65824 9.50891C9.65824 8.3768 8.88803 8.3768 8.88803 8.3768H8.48022H5.7193V10.806H8.69162C9.20525 10.8058 9.65824 10.6415 9.65824 9.50891Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88828 12.4839H5.7193V15.3934H8.74195C9.19666 15.3804 10.0359 15.238 10.0359 13.9792C10.0359 12.4687 8.88828 12.4839 8.88828 12.4839Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 10.8058C15.3193 10.8058 15.0848 12.4839 15.0848 12.4839H18.6608C18.6611 12.4839 18.6824 10.8058 17.0008 10.8058Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37256 0 0 5.37281 0 12C0 18.6272 5.37256 24 12 24C18.6274 24 24 18.6272 24 12C24 5.37281 18.6274 0 12 0ZM14.6163 7.08288H19.1079V8.42345H14.6163V7.08288ZM12.3462 14.1142C12.3462 17.4369 8.88823 17.3276 8.88823 17.3276H5.71924H5.62619H3.22324V6.44158H5.62619H5.71924H8.88798C10.6096 6.44158 11.9686 7.392 11.9686 9.33999C11.9686 11.2882 10.3074 11.4117 10.3074 11.4117C12.4972 11.4117 12.3462 14.1142 12.3462 14.1142ZM17.0222 15.8312C18.8317 15.8312 18.7676 14.66 18.7676 14.66H20.6835C20.6835 17.7681 16.9584 17.5552 16.9584 17.5552C12.4881 17.5552 12.7756 13.3936 12.7756 13.3936C12.7756 13.3936 12.7722 9.21134 16.9579 9.21134C21.3643 9.21134 20.7473 13.9365 20.7473 13.9365H15.1064C15.1064 15.9593 17.0222 15.8312 17.0222 15.8312Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.e2bac0457314da291ac9ce5d51776092.svg";
export { ForwardRef as ReactComponent };